<template>
  <div>
    <div class="row border-bottom">
      <nav class="navbar navbar-static-top navbar-fixed-top" style="margin-bottom: 0">
        <div class="navbar-header">
          <span>
            <a class="navbar-minimalize minimalize-styl-2 btn btn-primary" @click="minimalize">
              <i class="fa fa-bars"></i>
            </a>
          </span>
        </div>
        <ul class="nav navbar-top-links navbar-right">
          
          <!--li class="dropdown ">

              <a class="dropdown-toggle count-info" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" style="padding: 10px;">
                   <img src="../../assets/web.png" style="width: 27px;"/>
              </a>
              <ul class="dropdown-menu animated fadeInRight m-t-xs">
                  <li><a @click="changeLanguage('en_US')">English</a></li>
                  <li><a @click="changeLanguage('zh_HK')">繁體中文</a></li>
                  <li><a @click="changeLanguage('zh_CN')">简体中文</a></li>
              </ul>
          </li-->
          <li class="dropdown">
            <ul class="dropdown-menu dropdown-alerts">
              <li>
                <a ui-sref="inbox">
                  <div>
                    <i class="fa fa-envelope fa-fw"></i> You have 16 messages
                    <span class="pull-right text-muted small">4 minutes ago</span>
                  </div>
                </a>
              </li>
              <li class="divider"></li>
              <li>
                <a ui-sref="profile">
                  <div>
                    <i class="fa fa-twitter fa-fw"></i> 3 New Followers
                    <span class="pull-right text-muted small">12 minutes ago</span>
                  </div>
                </a>
              </li>
              <li class="divider"></li>
              <li>
                <a ui-sref="grid_options">
                  <div>
                    <i class="fa fa-upload fa-fw"></i> Server Rebooted
                    <span class="pull-right text-muted small">4 minutes ago</span>
                  </div>
                </a>
              </li>
              <li class="divider"></li>
              <li>
                <div class="text-center link-block">
                  <a ui-sref="miscellaneous.notify">
                    <strong>See All Alerts</strong>
                    <i class="fa fa-angle-right"></i>
                  </a>
                </div>
              </li>
            </ul>
          </li>
          <li>
            <span style="color: white">{{$store.state.userInfo.userName}}</span>
          </li>
          <li @click="logOut">
            <a>
              <i class="fa fa-sign-out"></i>
               {{$t("message.LogOut") }}
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>
<script>
import config from "../../config";
export default {
  name: "topnavbarController",
  mixins: [config.globalMixin],
  methods: {
    minimalize() {
      $("body").toggleClass("mini-navbar");
      if (
        !$("body").hasClass("mini-navbar") ||
        $("body").hasClass("body-small")
      ) {
        $("#side-menu").hide();
        setTimeout(function() {
          $("#side-menu").fadeIn(500);
        }, 100);
      } else if ($("body").hasClass("fixed-sidebar")) {
        $("#side-menu").hide();
      } else {
        $("#side-menu").removeAttr("style");
      }
    },
    async logOut() {
      if(this.$store.state.userInfo.loginType==2){
        let obj = this.getAuthObj();
     
        obj.apiUrl = '/logout'
        let data = await this.$store.dispatch("apiEvent", obj);
        // if(!data) return;
        window.location.href = this.adLogoutUrl;
      }else{
        var self = this;
        setTimeout(function(){
          self.$router.push({ path: "/" });
        })
      }
      this.$store.commit("login", "");
      sessionStorage.clear();
    },
    changeLanguage(lang){
        this.$i18n.locale =lang;
        this.$store.state.userInfo.langCode = lang;
    }
  }
};
</script>
